export default "__VITE_ASSET__CDrCh3QZ__"